import { useCreateWorkPlan } from "@api/workplanService";
import WorkPlanEdit from "./WorkPlanEdit";

export default function WorkPlanCreate() {
    return <WorkPlanEdit
        mutation={useCreateWorkPlan}
        title={'New Work Plan'}
        create
    />
}
